<script lang="ts">
	import { searchValue, isShowFilters, selectedFiltersCount } from './store'
  import { push } from 'svelte-spa-router'
  import { onDestroy, onMount } from 'svelte'
  import { init, destroy, search, openFiltersModal } from './services'

  import GeneralLayout from '../../../../layouts/GeneralLayout.svelte'
  import Button from '../../components/Button/Button.svelte'
  import Tabs from './components/Tabs/Tabs.svelte'
  import Filter from './components/Filter/Filter.svelte'
  import Table from './components/Table/Table.svelte'
  import ModalFilters from './components/ModalFilters/ModalFilters.svelte';
  import Count from './components/Сount/Count.svelte'

  onMount(init)
  onDestroy(destroy)
</script>

<GeneralLayout isEditor>
  <div class="header">
    <div>
      <div class="title">Редактор</div>
    </div>
    <Button label="Написать пост" on:click={() => push('/editor/create')} />
  </div>

  <Tabs />

  <div class="forms">
    <Filter 
      bind:value={$searchValue} 
      placeholder="Что ищем?" 
      on:search={search}
      let:isDirtySearch={isDirtySearch}
    >
      <span slot="icon">
        <i 
          class="icon-newsline-search" 
          style:margin-right={isDirtySearch ? '30px' : '0px'} 
        />
      </span>
    </Filter>

    <Filter  
      placeholder="Фильтры" 
      disabled
      on:click={openFiltersModal}
    >
      <span slot="icon">
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 10.5H1" stroke="#5A5F6D" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 3.5H14" stroke="#5A5F6D" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 3.5C5 2.39555 4.10445 1.5 3 1.5C1.89555 1.5 1 2.39555 1 3.5C1 4.60445 1.89555 5.5 3 5.5C4.10445 5.5 5 4.60445 5 3.5Z" stroke="#5A5F6D" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14 10.5C14 9.39555 13.1051 8.5 12.0007 8.5C10.8956 8.5 10 9.39555 10 10.5C10 11.6044 10.8956 12.5 12.0007 12.5C13.1051 12.5 14 11.6044 14 10.5Z" stroke="#5A5F6D" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>    

        {#if $selectedFiltersCount}
          <div class="filters-count">
            <Count count={$selectedFiltersCount} />
          </div>
        {/if}
      </span>
    </Filter>
  </div>

  {#if $isShowFilters}
    <ModalFilters />
  {/if}

  <Table />
</GeneralLayout>

<style lang="scss">
  .filters-count {
    position: absolute;
    top: -8px;
    right: -8px;  
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .forms {
    margin-top: 24px;
    display: grid;
    grid-template-columns: 1fr 130px;
    grid-gap: 8px;
  }

  .title {
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    color: #30333D;
    margin-bottom: 8px;
  }
</style>